import React, { useState } from "react";
import { RxCross2 } from "react-icons/rx";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Import Quill CSS for styling
import { useDispatch } from "react-redux";
import { updateL1Property } from "../WorkbookSlice";

export default function Quill({
  handleQuillSave,
  quillContent,
  closeModal,
  items,
  dashboardSheetID,
  isQuillEditing,
  handleRemoveItem,
}) {
  const [quillData, setQuillData] = useState(quillContent);
  console.log(items);
  console.log(isQuillEditing);

  const handleChange = (value) => {
    setQuillData(value);
  };

  const dispatch = useDispatch();
  const handleSave = () => {
    // Save the Quill data
    handleQuillSave(quillData);
    console.log("Original Items:", items);

    // Create a default Quill item object
    let quillItemObject = {
      Sheetid: isQuillEditing,
      SheetName: "Paragraph",
      x: 0,
      y: 0,
      width: 8,
      height: 4,
      quillContent: quillData, // Set the initial Quill content
    };

    // Check if the item already exists
    const existingItemIndex = items.findIndex(
      (item) => item.Sheetid === isQuillEditing
    );

    let updatedItems;
    if (existingItemIndex === -1) {
      // If not found, add the new Quill item to the array
      updatedItems = [...items, quillItemObject];
      console.log("Item not found, added new Quill item:", quillItemObject);
    } else {
      // If found, update only the Quill content of the existing item
      updatedItems = items.map((item, index) =>
        index === existingItemIndex
          ? { ...item, quillContent: quillData }
          : item
      );
      console.log(
        "Item found, updated Quill content:",
        updatedItems[existingItemIndex]
      );
    }

    console.log("Updated Items:", updatedItems);

    // Dispatch the updated items to Redux
    dispatch(
      updateL1Property({
        SheetId: dashboardSheetID,
        key: "SheetsArray",
        value: updatedItems,
      })
    );

    // Close the modal
    closeModal();
  };
  const handleKeyDown = (event) => {
    if (event.ctrlKey && event.key === "Enter") {
      handleSave(); // Call your function here
    }
  };  

  console.log(quillData);
  console.log(quillContent);

  return (
    <main
      className="fixed inset-0 bg-gray-900 bg-opacity-50 flex items-center justify-center z-50"
      onKeyDown={handleKeyDown} // Attach the key event handler here
      tabIndex="0" // Make the element focusable to capture key events
    >
      <section className="bg-white p-4 rounded w-[75%] h-[60%] flex flex-col gap-2">
        <div className="flex justify-between items-center">
          <h2 className="text-xl font-medium">Text Editor</h2>
          <button
            onClick={() => {
              closeModal();
              handleRemoveItem(isQuillEditing);
            }}
            className="p-1"
          >
            <RxCross2 />
          </button>
        </div>
        <ReactQuill
          theme="snow"
          value={quillData}
          onChange={handleChange}
          placeholder="Write something..."
          className="h-full"
        />
        <div className="flex justify-end">
          <button
            onClick={handleSave}
            className="bg-blue-950 text-white px-3 py-1 tracking-wider rounded "
          >
            Save
          </button>
        </div>
      </section>
    </main>
  );
}
